import { render } from "./ProductGallery.vue?vue&type=template&id=5cfadcc4&scoped=true"
import script from "./ProductGallery.vue?vue&type=script&lang=js"
export * from "./ProductGallery.vue?vue&type=script&lang=js"

import "./ProductGallery.vue?vue&type=style&index=0&id=5cfadcc4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bdroyelfrontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfadcc4"]])

export default __exports__